import type { RouteRecordRaw } from 'vue-router';

export const docRoutes: Array<RouteRecordRaw> = [
  {
    path: '/document',
    name: 'document',
    redirect: '/document/list',
    component: () => import('pages/central/doc/McDoc.vue'),
    meta: {
      title: 'Document Management',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'documentList',
        component: () => import('pages/central/doc/DocList.vue'),
        meta: {
          title: 'Documents List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail',
        name: 'documentDetail',
        component: () => import('pages/central/doc/DocDetail.vue'),
        meta: {
          title: 'Document Details',
          requiresAuth: true,
        },
        // /:itemId?/:categoryId?/:activityId?/:folderId?/:appId?/:title?/:refPageId?
      },
      {
        path: 'new',
        name: 'documentNew',
        component: () => import('pages/central/doc/DocNew.vue'),
        meta: {
          title: 'New Document',
          requiresAuth: true,
        },
      },
    ],
  },
];
